import React, { useState } from "react";
import TextFiled from "../../../components/common/InputField/TextFiled";
import TextArea from "../../../components/common/InputField/TextArea";
import MainButton from "../../../components/common/MainButton/MainButton";
import Paragraph from "../../../components/common/Typography/Paragraph";
import AuxiliaryText from "../../../components/common/Typography/AuxiliaryText";
import Heading from "../../../components/common/Typography/Heading";
import { useNavigate } from "react-router-dom";
import { runTextPipeline, validateFile, getAcceptAttribute } from "../../../utils/contentSafety";
import Alerts from "../../../components/common/Alerts/Alerts";
import {
  PUBLIC_FORM_FIELD_GAP_CLASS,
  PUBLIC_FORM_TO_ACTION_CLASS,
  PUBLIC_HEADING_TO_BODY_CLASS,
  PUBLIC_HEADING_TO_CONTENT_CLASS,
} from "../../Public/shared/publicLayoutSpec";
import { FIELD_UPLOAD_FULL } from "../../../components/common/InputField/fieldSystem";

const GeneralInquiry = () => {
  const [step, setStep] = useState(1);
  const navigate = useNavigate();
  const [fullName, setFullName] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [inquiryFiles, setInquiryFiles] = useState([]);
  const [fieldErrors, setFieldErrors] = useState({ fullName: "", subject: "", message: "" });
  return (
    <>
      {step === 1 && (
        <>
          <div className={PUBLIC_FORM_FIELD_GAP_CLASS}>
            <TextFiled
              variant={"general"}
              fullWidth
              label={"Tradesposter username"}
              placeholder={"Enter your Tradesposter username (optional)"}
            />
          </div>
          <div className={PUBLIC_FORM_FIELD_GAP_CLASS}>
            <TextFiled
              variant={"general"}
              fullWidth
              label={"Full Name"}
              placeholder={"Enter your first name"}
              star={false}
              value={fullName}
              error={fieldErrors.fullName || null}
              onChange={(e) => { setFullName(e.target.value); setFieldErrors((prev) => ({ ...prev, fullName: "" })); }}
            />
          </div>
          <div className={PUBLIC_FORM_FIELD_GAP_CLASS}>
            <TextFiled
              variant={"general"}
              fullWidth
              label={"Mobile"}
              placeholder={"Enter your mobile number"}
            />
          </div>
          <div className={PUBLIC_FORM_FIELD_GAP_CLASS}>
            <TextFiled
              variant={"general"}
              fullWidth
              label={"Email address"}
              placeholder={"Enter your email address"}
            />
          </div>
          <div className={PUBLIC_FORM_FIELD_GAP_CLASS}>
            <TextFiled
              variant={"general"}
              fullWidth
              label={"Subject"}
              placeholder={"Enter your quiry subject"}
              value={subject}
              error={fieldErrors.subject || null}
              onChange={(e) => { setSubject(e.target.value); setFieldErrors((prev) => ({ ...prev, subject: "" })); }}
            />
          </div>
          <div className={PUBLIC_FORM_FIELD_GAP_CLASS}>
            <TextArea
              variant={"page"}
              fullWidth
              label={"Message"}
              placeholder={"Please briefly describe your quiry"}
              value={message}
              error={fieldErrors.message || null}
              onChange={(e) => { setMessage(e.target.value); setFieldErrors((prev) => ({ ...prev, message: "" })); }}
            />
          </div>
          <div className={PUBLIC_FORM_FIELD_GAP_CLASS}>
            <label htmlFor="general-inquiry-files" className="mb-2 block">
              <AuxiliaryText variant={"FieldLabel"}>Attatchment</AuxiliaryText>
            </label>
            <div className="w-full min-w-0">
              <input
                type="file"
                id="general-inquiry-files"
                accept={getAcceptAttribute("image")}
                className="hidden"
                multiple
                onChange={(e) => {
                  const files = e.target.files ? Array.from(e.target.files) : [];
                  for (const file of files) {
                    const result = validateFile(file, "image");
                    if (!result.valid) {
                      Alerts.error(result.message);
                      e.target.value = "";
                      return;
                    }
                  }
                  setInquiryFiles(files);
                  e.target.value = "";
                }}
              />
              <label
                role="button"
                htmlFor="general-inquiry-files"
                className={`${FIELD_UPLOAD_FULL} flex cursor-pointer items-center justify-center`}
              >
                <div className="my-auto">
                  <div className="flex justify-center">
                    <div className="flex justify-center items-center">
                      <i className="fi fi-rs-inbox-out text-base text-offblack"></i>
                    </div>
                  </div>
                  <div className="flex justify-center">
                    <AuxiliaryText
                      variant={"Placeholder"}
                      className={"mt-1 text-primaryblue"}
                    >
                      Click to upload
                    </AuxiliaryText>
                  </div>
                </div>
              </label>
            </div>
          </div>
          {/* <div className="mt-10 w-full">
            <div className="flex gap-3 w-full">
              <i className="fi fi-br-picture text-[30px] lg:text-[50px] text-primaryblue mt-auto"></i>
              <div className="w-full flex flex-col gap-2 mt-5">
                <div className="flex items-center justify-between w-full">
                  <AuxiliaryText variant={"FieldLabel"}>
                    myprofile.png
                  </AuxiliaryText>

                  <AuxiliaryText variant={"FieldLabel"}>
                    {completion}%
                  </AuxiliaryText>
                </div>
                <div className="w-full h-1.5 bg-pastalblue rounded-full">
                  <div
                    className={`h-full bg-primaryblue rounded-full`}
                    style={{ width: `${completion}%` }}
                  ></div>
                </div>
              </div>
              <i className="fi fi-rs-cross text-sm cursor-pointer mt-10"></i>
            </div>
          </div> */}
          <div className={`flex justify-end ${PUBLIC_FORM_TO_ACTION_CLASS}`}>
            <MainButton
              variant={"small"}
              onClick={() => {
                setFieldErrors({ fullName: "", subject: "", message: "" });
                const trimName = fullName.trim();
                const trimSubj = subject.trim();
                const trimMsg = message.trim();
                if (!trimName) {
                  setFieldErrors((prev) => ({ ...prev, fullName: "Full name is required." }));
                  return;
                }
                if (!trimSubj) {
                  setFieldErrors((prev) => ({ ...prev, subject: "Subject is required." }));
                  return;
                }
                if (!trimMsg) {
                  setFieldErrors((prev) => ({ ...prev, message: "Message is required." }));
                  return;
                }
                const nameResult = runTextPipeline(trimName, "name");
                if (!nameResult.valid) {
                  setFieldErrors((prev) => ({ ...prev, fullName: nameResult.message }));
                  return;
                }
                const subjResult = runTextPipeline(trimSubj, "supportSubject");
                if (!subjResult.valid) {
                  setFieldErrors((prev) => ({ ...prev, subject: subjResult.message }));
                  return;
                }
                const msgResult = runTextPipeline(trimMsg, "support");
                if (!msgResult.valid) {
                  setFieldErrors((prev) => ({ ...prev, message: msgResult.message }));
                  return;
                }
                setStep(2);
                setTimeout(() => navigate("/HelpCentre"), 3000);
              }}
            >
              Submit
            </MainButton>
          </div>
        </>
      )}
      {step === 2 && (
        <>
          <div className={`w-fit mx-auto ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}>
            <Heading variant={"h6"} className={"text-offblack"}>
              Submission received - thank you!
            </Heading>
            <Paragraph
              variant={"MainParagraph"}
              className={`text-offblack ${PUBLIC_HEADING_TO_BODY_CLASS}`}
            >
              Your submission has been successfully received.
            </Paragraph>
          </div>
        </>
      )}
    </>
  );
};

export default GeneralInquiry;
